import { render, staticRenderFns } from "./FullWidthBanner.vue?vue&type=template&id=2e90a99a&scoped=true"
import script from "./FullWidthBanner.vue?vue&type=script&lang=js"
export * from "./FullWidthBanner.vue?vue&type=script&lang=js"
import style0 from "./FullWidthBanner.vue?vue&type=style&index=0&id=2e90a99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e90a99a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FullWidthBanner.vue
// module id = 144
// module chunks = 0